/** @format */

export interface StyleDescriptiveAttribute {
  identifier: string;
  isDisplayable: boolean;
  isFacetable?: boolean;
  name: string;
  seq?: number;
  storeId?: number;
  value: string | number;
}
